// TODO Align with design
export const API = Object.freeze({
  localUrl: 'http://127.0.0.1:8000/api/v1',
});

export const baseURL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000/api/v1';
